import { Injectable, signal, TemplateRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private readonly _pageTitle = signal<string>('Personal Dashboard');
  /**
   * Optional content projected into the navbar's title row, replacing the plain
   * `pageTitle` text — mirrors legacy's `*appNavbarView` structural directive
   * (e.g. `incident-header` renders breadcrumb + title + actions-menu here).
   */
  private readonly _navbarContent = signal<TemplateRef<unknown> | null>(null);
  private readonly _menuOpen = signal<boolean>(false);
  /** When true the DefaultLayout hides the "Create incident" button — set by the wizard page */
  private readonly _wizardActive = signal<boolean>(false);
  /**
   * Width of the wizard sidebar in px — mirrors legacy app-split-area width.
   * Updated by CreateIncidentComponent on drag-resize so DefaultLayout can shift
   * the navbar left-offset to match (legacy: .app__navbar { left: 100% of split-wrap })
   */
  private readonly _wizardSidebarWidth = signal<number>(240);
  /** When true the DefaultLayout hides the "Create incident" button — matches legacy setNavbar(title, false) */
  private readonly _hideCreateButton = signal<boolean>(false);

  readonly pageTitle = this._pageTitle.asReadonly();
  readonly navbarContent = this._navbarContent.asReadonly();
  readonly menuOpen = this._menuOpen.asReadonly();
  readonly wizardActive = this._wizardActive.asReadonly();
  readonly wizardSidebarWidth = this._wizardSidebarWidth.asReadonly();
  readonly hideCreateButton = this._hideCreateButton.asReadonly();

  setPageTitle(title: string): void {
    this._pageTitle.set(title);
  }

  /** Registers a template to render inside the navbar's title row instead of the plain title text. */
  setNavbarContent(template: TemplateRef<unknown> | null): void {
    this._navbarContent.set(template);
  }

  setHideCreateButton(hide: boolean): void {
    this._hideCreateButton.set(hide);
  }

  setWizardActive(active: boolean): void {
    this._wizardActive.set(active);
    if (!active) {
      this._wizardSidebarWidth.set(240); // reset to default on exit
    }
  }

  setWizardSidebarWidth(px: number): void {
    this._wizardSidebarWidth.set(px);
  }

  toggleMenu(): void {
    this._menuOpen.update(open => !open);
  }

  closeMenu(): void {
    this._menuOpen.set(false);
  }

  openMenu(): void {
    this._menuOpen.set(true);
  }
}
